module.exports = __webpack_public_path__ + "img/slide_3.27c15e70.jpg";